"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStyleClasses = void 0;

// eslint-disable-next-line import/prefer-default-export
var getStyleClasses = function getStyleClasses(withValue, isDisabled) {
  if (withValue) {
    if (isDisabled) {
      return ['text-gray-350', 'bg-white'];
    }

    return ['text-black', 'bg-white'];
  }

  return ['bg-gray-100', 'text-gray-350'];
};

exports.getStyleClasses = getStyleClasses;